/**
 * 路由配置：集中定义页面路径与布局结构。
 */

import { createBrowserRouter, type RouteObject } from 'react-router-dom'
import {
  GenerationRecordsPage,
  BatchTaskDetailPage,
  ImagePackCenterPage,
  LoginPage,
  CrawlBatchesPage,
  CrawlBatchDetailPage,
  NotFoundPage,
  PricingPage,
  ProductKitPage,
  ProfilePage,
  ExclusiveComputePage,
  ImpersonatePage,
  RechargeRecordsPage,
  BillingRecordsPage,
  WorkflowDetailPage,
  WorkflowsPage,
  SystemUpdatesPage,
  SystemUpdateDetailPage,
  SensitiveWordFilterPage,
  ImageToTextToolPage,
  ImageToTextRecordsPage,
  ImageToTextTaskDetailPage,
} from '@/pages'
import { RootLayout } from '@/components/layout/RootLayout'
import { WideNavbarLayout } from '@/components/layout/WideNavbarLayout'

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/impersonate',
    element: <ImpersonatePage />,
  },
  {
    path: '/product-kit',
    element: <WideNavbarLayout />,
    children: [
      {
        index: true,
        element: <ProductKitPage />,
      },
    ],
  },
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <WorkflowsPage />,
      },
      {
        path: 'workflows',
        children: [
          { index: true, element: <WorkflowsPage /> },
          { path: ':workflowId', element: <WorkflowDetailPage /> },
        ],
      },
      {
        path: 'pricing',
        element: <PricingPage />,
      },
      {
        path: 'tools',
        children: [
          { path: 'sensitive-word-filter', element: <SensitiveWordFilterPage /> },
          { path: 'ai-analysis', element: <ImageToTextToolPage /> },
        ],
      },
      {
        path: 'updates',
        children: [
          { index: true, element: <SystemUpdatesPage /> },
          { path: ':updateId', element: <SystemUpdateDetailPage /> },
        ],
      },
      {
        path: 'materials',
        children: [
          { index: true, element: <CrawlBatchesPage /> },
          { path: ':batchId', element: <CrawlBatchDetailPage /> },
        ],
      },
      {
        path: 'records',
        children: [
          { path: 'generations', element: <GenerationRecordsPage /> },
          { path: 'generations/:batchId', element: <BatchTaskDetailPage /> },
          { path: 'downloads', element: <ImagePackCenterPage /> },
          { path: 'recharges', element: <RechargeRecordsPage /> },
          { path: 'billing', element: <BillingRecordsPage /> },
          { path: 'tools', element: <ImageToTextRecordsPage /> },
          { path: 'tools/:taskId', element: <ImageToTextTaskDetailPage /> },
        ],
      },
      {
        path: 'me',
        element: <ProfilePage />,
      },
      {
        path: 'exclusive-compute',
        element: <ExclusiveComputePage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
]

export const router = createBrowserRouter(routes)
